<template>
  <div class="content">
    <div class="complete-message">
      <p>お取引申込みを承りました。</p>
      <p>
        担当よりご連絡を差し上げますので、
        <br v-if="isMobile" />
        少々お待ち下さい。
      </p>
    </div>
    <div class="page-btn-wrapper mt-3">
      <md-button
        type="button"
        class="btn-lg btn-success page-btn col-10 col-md-6 mx-lg-4"
        to="/"
      >
        トップ画面にもどる
      </md-button>
    </div>
  </div>
</template>
<script>
import {} from 'vuelidate/lib/validators'
import Mixin from '../mixin/Mixin'
export default {
  name: 'Complete',
  mixins: [Mixin],
  components: {},
  data: () => ({}),
  validations: {},
  methods: {},
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.complete-message
  text-align: center
  margin-top: 80px
  font-size: 22px
  font-weight: bold
  @include sp
    font-size: 14px
</style>



// WEBPACK FOOTER //
// src/components/apply/Complete.vue